<edit-modal-layout [form]="form"
  [pageTitle]="pageTitle"
  (onCancel)="cancel()"
  (save)="confirmUpdate()"
  [canSave]="selectedStep===2"
  >

  <mat-horizontal-stepper #stepper (selectionChange)="stepSelected($event)">
    <mat-step [stepControl]="firstFormGroup" [errorMessage]="'Missing required fields' | translate">
      <form [formGroup]="firstFormGroup" class="flex-form">

        @if (isFormProvided) {
          <ng-template matStepLabel>{{ storeSelectionLabel | async }}</ng-template>
          <div class="store-selection">
            <app-store-autocomplete #storeAutocomplete [formGroup]="form" [required]="true" [limitToAccountIds]="accountIds" (storeChanged)="onStoreSelected($event)"></app-store-autocomplete>
          </div>
        }

        @if (!isFormProvided) {
          <ng-template matStepLabel>{{'Form Selection' | translate}}</ng-template>
          <mat-form-field>
            <mat-label>{{'Form ' | translate}}</mat-label>
            <mat-select formControlName="form" id="form">
              @for (item of forms; track item) {
                <mat-option value={{item.id}}>
                  {{ item.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <div class="stepper-buttons">
          <button mat-flat-button
            color="primary" id="next1"
            class="stepper-buttons__next"
            matStepperNext
            type="button"
          >{{'Next' | translate}}</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="secondFormGroup" [errorMessage]="'Missing required fields' | translate">
      <form [formGroup]="secondFormGroup" class="flex-form">
        <ng-template matStepLabel>{{'Schedule Calendar Event' | translate}}</ng-template>

        <div class="book-event">

          <mat-form-field>
            <mat-label>{{'Calendar Event Type ' | translate}}</mat-label>

            <mat-select formControlName="eventType"
              id="eventType">
              @for (item of eventTypes; track item) {
                <mat-option value={{item.id}}>
                  {{ item.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <input [matDatepicker]="startDatePicker" formControlName="startDate" matInput name="startDate" id="startDate"
              placeholder="{{'Start Date' | translate}}">
            <mat-datepicker-toggle [for]="startDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            @if (secondFormGroup.get('startDate').errors?.required) {
              <mat-error>
                {{'Start Date is required.' | translate}}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <input formControlName="startTime" matInput placeholder="{{'Start Time' | translate}}" type="time" id="startTime">
            @if (secondFormGroup.get('startTime').errors?.required) {
              <mat-error>
                {{'Start Time is required.' | translate}}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <input [matDatepicker]="endDatePicker" formControlName="endDate" id="endDate" matInput name="endDate" [min]="secondFormGroup.get('startDate').value"
              placeholder="{{'End Date' | translate}}">
            <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
            @if (secondFormGroup.get('endDate').errors?.required) {
              <mat-error>
                {{'End Date is required.' | translate}}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <input formControlName="endTime" matInput id="endTime" placeholder="{{'End Time' | translate}}" type="time">
            @if (secondFormGroup.get('endTime').errors?.required) {
              <mat-error>
                {{'End Time is required.' | translate}}
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{'Event Notes' | translate}}</mat-label>
            <textarea formControlName="notes" matInput cdkTextareaAutosize [cdkAutosizeMinRows]="2" id="notes"
              [placeholder]="'Event Notes' | translate" type="text"
            (keydown.enter)="$event.stopPropagation()"></textarea>

          </mat-form-field>

          <mat-form-field>
            <mat-label>{{'User Group' | translate}}</mat-label>

            <mat-select formControlName="group" id="group"
              id="group">
              @for (item of groups; track item) {
                <mat-option value={{item.id}}>
                  {{ item.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="stepper-buttons">
          <button mat-flat-button
            color="primary"
            class="stepper-buttons__back"
            matStepperPrevious id="previous1"
            type="button"
          >{{'Back' | translate}}</button>

          <button mat-flat-button
            color="primary"
            class="stepper-buttons__next"
            matStepperNext id="next2"
            type="button"
          >{{'Next' | translate}}</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{'Start Visit' | translate}}</ng-template>
      <div class="flex-form">
        @if (this.form.dirty && this.form.valid) {
          <div
            class="confirm">
            <div>
              {{'We are all set!' | translate}}
            </div>
          </div>
        }
        @if (!this.form.dirty || !this.form.valid) {
          <div
            class="confirm">
            <div>
              {{'Missing required fields' | translate}}
            </div>
          </div>
        }
      </div>

      <div class="stepper-buttons">
        @if (!this.form.dirty || !this.form.valid) {
          <button mat-flat-button
            color="primary"
            class="stepper-buttons__back"
            matStepperPrevious id="previous2"
            type="button"
          >{{'Back' | translate}}</button>
        }
      </div>

    </mat-step>
  </mat-horizontal-stepper>

</edit-modal-layout>
